import { render, staticRenderFns } from "./EnhancedEditor.vue?vue&type=template&id=b189dfa6&scoped=true"
import script from "./EnhancedEditor.vue?vue&type=script&lang=js"
export * from "./EnhancedEditor.vue?vue&type=script&lang=js"
import style0 from "./EnhancedEditor.vue?vue&type=style&index=0&id=b189dfa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b189dfa6",
  null
  
)

export default component.exports